export default function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-7 border-t border-[var(--border)] pt-6 first:mt-0 first:border-t-0 first:pt-0">
      <h2 className="mb-2 text-base font-semibold">{title}</h2>
      {children}
    </section>
  );
}
